// extracted by mini-css-extract-plugin
export default {"checkbox":"Blp7t9"};